module.exports = __webpack_public_path__ + "img/47.acb6754.jpg";